module.exports = __webpack_public_path__ + "static/media/location.2d5bb071.svg";